import React from 'react';
import ExperienceCard from "./ExperienceCard";
import { Jumbotron } from './migration';
import { Container } from "react-bootstrap";
import "./Experience.css";

const Experience = ({ experiences }) => {
  // Reverse the array so oldest is first (top) and newest is last (bottom)
  const chronologicalData = [...experiences.data].reverse();

  return (
    <section id="experiences" className="section section-block section-experiences py-5">
      <Container>
        <Jumbotron className="bg-transparent p-0" style={{ backgroundColor: "transparent" }}>
          <h2 className="display-4 mb-5 text-center fw-bold">
            {experiences.heading}
          </h2>

          <div className="timeline-wrapper">
            {/* The vertical spine track */}
            <div className="timeline-track" />

            {/* Render Cards */}
            {chronologicalData.map((data, index) => (
              <ExperienceCard
                key={index}
                data={data}
                isLast={index === chronologicalData.length - 1}
              />
            ))}
          </div>
        </Jumbotron>
      </Container>
    </section>
  );
};

export default Experience;